import React, { useRef, useState, useEffect } from 'react';
import ExecutiveTab from './tabs/ExecutiveTab';
import DetailedTab from './tabs/DetailedTab';
import JourneyReportsTab from './tabs/JourneyReportsTab';
import { useTheme } from '../../../utils/theme-context';

const InsightsTabs = [
    { name: 'Executive Dashboard', element: <ExecutiveTab /> },
    { name: 'Detailed View', element: <DetailedTab /> },
    { name: 'Journey Reports', element: <JourneyReportsTab /> },
]

const HomepageAdmin = () => {
    const [activeTab, setActiveTab] = useState<any>(InsightsTabs?.[0]);
	const { theme } = useTheme();
    const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);
    const [sliderStyle, setSliderStyle] = useState<{ left: number; width: number }>({ left: 0, width: 0 });

    const onClickTab = (tab: any) => {
        setActiveTab(tab)
    }

    // Update slider position whenever activeTab changes
    useEffect(() => {
        const idx = InsightsTabs.findIndex((t) => t.name === activeTab?.name);
        const el = tabRefs.current[idx];
        const container = containerRef.current;
        if (el && container) {
            const containerRect = container.getBoundingClientRect();
            const elRect = el.getBoundingClientRect();
            setSliderStyle({
                left: elRect.left - containerRect.left,
                width: elRect.width,
            });
        }
    }, [activeTab]);

    return (
        <div>
            <div className='bg-white dark:bg-transparent'>
                <div className='flex flex-row justify-start'>
                    <div
                        ref={containerRef}
                        className='my-5 relative flex flex-row items-center'
                        style={{
                            backgroundColor: theme === 'dark' ? '#1F1F1F' : '#141420',
                            padding: '2px',
                            borderRadius: '24px',
                            borderWidth: '1px',
                            borderColor: theme === 'dark' ? '#252B37' : '#141420',
                            height: '43px',
                        }}
                    >
                        {/* Sliding background */}
                        <div
                            className='absolute top-[2px] bottom-[2px] bg-white rounded-[22px] transition-all duration-300 ease-in-out'
                            style={{
                                left: sliderStyle.left,
                                width: sliderStyle.width,
                            }}
                        />

                        {InsightsTabs?.map((item: any, idx: number) => {
                            const isActive = activeTab?.name === item?.name;
                            return (
                                <div
                                    key={idx}
                                    ref={(el) => { tabRefs.current[idx] = el; }}
                                    onClick={() => onClickTab(item)}
                                    className='relative z-10 cursor-pointer select-none flex items-center justify-center hover:opacity-90 transition-colors duration-300'
                                    style={{
                                        padding: '0 20px',
                                        borderRadius: '20px',
                                        height: '100%',
                                    }}
                                >
                                    <p
                                        className='transition-colors duration-300 whitespace-nowrap'
                                        style={{
                                            fontFamily: 'Inter, sans-serif',
                                            fontWeight: 500,
                                            fontSize: '16px',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.02em',
                                            color: isActive ? '#0A0D12' : '#ffffff',
                                        }}
                                    >
                                        {item?.name}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {activeTab?.element}
            </div>
        </div>
    )
}
export default HomepageAdmin;